/**
 * 公共路由
 */
 const Layout = () => import(/* webpackChunkName: "Layout" */'@/components/layout/Layout')
 export default [
     {
         path: '/',
         redirect: "/union"
     },
     {
         path: '/homepage',
         component: Layout,
         children: [{
             path: '/',
             name: 'Homepage',
             component: () => import(/* webpackChunkName: "homepage" */'@serviceapp/homepage/Index'),
             meta: { text: '首页',name:"Homepage"}
         }]
     },
     {
         path: '/login',
         hidden: true,
         name: 'Login',
         component: () => import(/* webpackChunkName: "login" */'@/views/login/Index')
     },
     {
        path: '/union',
        hidden: true,
        name: 'Union',
        component: () => import(/* webpackChunkName: "union" */'@/views/union/Index')
    },
     // {
     //    path: '/registerPic',
     //    hidden: true,
     //    name: 'RegisterPic',
     //    component: () => import(/* webpackChunkName: "registerPic" */'@/views/registerPic/Index')
    // },
    //  {
    //      path: '/registerPicN',
    //      hidden: true,
    //      name: 'RegisterPic',
    //      component: () => import(/* webpackChunkName: "registerPicN" */'@/views/registerPicN/Index')
    //  },
     {
         path: '/updatePassword',
         hidden: true,
         name: 'UpdatePassword',
         component: () => import(/* webpackChunkName: "updatePassword" */'@/views/serviceapp/systemManage/passwordManage/updatePassword/Index')
     },
    {
        path: '/qrCode',
        hidden: true,
        name: 'QrCode',
        component: () => import(/* webpackChunkName: "qrCode" */'@/views/qrCode/Index')
    },
    {
        path: '/fqrCode',
        hidden: true,
        name: 'FQrCode',
        component: () => import(/* webpackChunkName: "fqrCode" */'@/views/fqrCode/Index')
    },
    //  {
    //      path: '/map',
    //      hidden: true,
    //      name: 'Map',
    //      component: () => import(/* webpackChunkName: "map" */'@serviceapp/map/Index')
    //  },
    //  {
    //     path: '/mapnew',
    //     hidden: true,
    //     name: 'Mapnew',
    //     component: () => import(/* webpackChunkName: "mapnew" */'@serviceapp/mapnew/Index')
    // },
    {
        path: '/homenew',
        hidden: true,
        name: 'Homenew',
        component: () => import(/* webpackChunkName: "homenew" */'@serviceapp/homenew/Index')
    },
     {
         path: '/',
         component: Layout,
         children: [
             {
             path: '*',
             name: '404',
             hidden: true,
             meta: { text: '404',name:"404" },
             component: () => import(/* webpackChunkName: "404" */'@/views/404/Index'),
         }
     ]
     },
 ]
